import { createContext, useContext } from "react";
type NativeModalPortalValue = {
  sheetPosition: number;
  register: (dismiss: () => void) => () => void;
};
export const NativeModalPortalContext = createContext<NativeModalPortalValue | null>(null);
export const useNativeModalPortal = () => useContext(NativeModalPortalContext);